import getBasePath from '../functions/api-resource';
import empresa from '../functions/company';

const basePath = getBasePath('api', 'v1');

const openpayActions = {
    guardarCliente: { method: 'POST', url: `${basePath}?conexion=${empresa}` },
    deleteCliente: { method: 'DELETE', url: `${basePath}/{idUsuario}?conexion=${empresa}` },
    getCliente: { method: 'GET', url: `${basePath}/{idUsuario}?conexion=${empresa}` },
    guardarTarjeta: { method: 'POST', url: `${basePath}/{idUsuario}/card?conexion=${empresa}` },
    getTarjetasCliente: { method: 'GET', url: `${basePath}/{idUsuario}/card?conexion=${empresa}` },
    deleteTarjetasCliente: { method: 'GET', url: `${basePath}/{idUsuario}/card/{idCard}?conexion=${empresa}` },
    postCargo: { method: 'POST', url: `${basePath}/MP/{idPedido}` },
    getCargo: { method: 'GET', url: `${basePath}/{idUsuario}/charge/{idCargo}?conexion=${empresa}` },
    cargo3dSecure: { method: 'POST', url: `https://sandbox-api.openpay.mx/v1/{merchant_id}/charges?conexion=${empresa}` },

};

export default resource => resource(`${basePath}`, {}, openpayActions);


// WEBPACK FOOTER //
// ./src/common/resources/mp.js